// extracted by mini-css-extract-plugin
module.exports = {"tduControl":"TduControl_tduControl__3s_QF"};